import { render } from "./LoanCalculatorBorrower.vue?vue&type=template&id=b7533746&scoped=true"
import script from "./LoanCalculatorBorrower.vue?vue&type=script&lang=js"
export * from "./LoanCalculatorBorrower.vue?vue&type=script&lang=js"

import "./LoanCalculatorBorrower.vue?vue&type=style&index=0&id=b7533746&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7533746"]])

export default __exports__